const CLOUD = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;

function isAbsoluteUrl(value) {
  return /^https?:\/\//i.test(value || '');
}

function assertCloudName() {
  if (!CLOUD && process.env.NODE_ENV === 'development') {
    console.warn('[cloudinary] REACT_APP_CLOUDINARY_CLOUD_NAME is not set');
  }
}

function buildTransforms({ width, height, quality = 'auto', format = 'auto', crop }) {
  const parts = [];
  if (width) parts.push(`w_${width}`);
  if (height) parts.push(`h_${height}`);
  if (crop) parts.push(`c_${crop}`);
  else if (width && height) parts.push('c_limit');
  parts.push(`f_${format}`, `q_${quality}`);
  return parts.join(',');
}

/** Build a Cloudinary image delivery URL from a public ID. */
export function cldImage(publicId, options = {}) {
  assertCloudName();
  const transforms = buildTransforms(options);
  return `https://res.cloudinary.com/${CLOUD}/image/upload/${transforms}/${publicId}`;
}

/** Build a Cloudinary video delivery URL from a public ID. */
export function cldVideo(publicId, options = {}) {
  assertCloudName();
  const transforms = buildTransforms(options);
  return `https://res.cloudinary.com/${CLOUD}/video/upload/${transforms}/${publicId}`;
}

/** Poster frame from a video public ID (1s in). */
export function cldVideoPoster(publicId, options = {}) {
  assertCloudName();
  const { width, height } = options;
  const size = width && height ? `w_${width},h_${height},c_limit,` : '';
  return `https://res.cloudinary.com/${CLOUD}/video/upload/so_1,${size}${publicId}.jpg`;
}

/**
 * Resolve image src: pass through absolute URLs, otherwise treat as Cloudinary public ID.
 */
export function resolveImageSrc(value, options) {
  if (!value) return '';
  if (isAbsoluteUrl(value)) return value;
  return cldImage(value, options);
}

/**
 * Resolve video src: pass through absolute URLs, otherwise treat as Cloudinary public ID.
 */
export function resolveVideoSrc(value, options) {
  if (!value) return '';
  if (isAbsoluteUrl(value)) return value;
  return cldVideo(value, options);
}

/**
 * Resolve video poster: explicit poster ID/URL, or auto-generate from video public ID.
 */
export function resolveVideoPosterSrc(poster, videoPublicId, options = { width: 1400, height: 700 }) {
  if (poster) return resolveImageSrc(poster, options);
  if (videoPublicId && !isAbsoluteUrl(videoPublicId)) return cldVideoPoster(videoPublicId, options);
  return undefined;
}
